<template>
    <div>
        <RegistrationLayout :loanPossibility="loanPossibility" :phase="0" :title="$t('register')">
            <v-card-text class="registration-card">
                <form>
                    <v-row dense>
                        <v-col align="center" justify="center">
                            <p v-html="getPossibilityHint"></p>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" md="6" v-if="app_settings.is_surname_required">
                            <v-text-field
                                v-model="form.surname.value"
                                v-validate="'required|max:50'"
                                :error-messages="errors.collect('surname')"
                                data-vv-name="surname"
                                required
                                :label="$t('surname')"
                                outlined
                                @focus="setFocusedElement('surname')"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" v-if="app_settings.is_name_required">
                            <v-text-field
                                :label="$t('name')"
                                outlined
                                v-model="form.name.value"
                                v-validate="'required|max:50'"
                                :error-messages="errors.collect('name')"
                                data-vv-name="name"
                                required
                                @focus="setFocusedElement('name')"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" v-if="app_settings.is_passport_required">
                            <v-text-field
                                v-if="$t('mask.passport')"
                                :label="$t('attributes.passport')"
                                outlined
                                v-model="form.passport.value"
                                v-validate="'required|max:20'"
                                :error-messages="errors.collect('passport')"
                                data-vv-name="passport"
                                required
                                v-mask="$t('mask.passport')"
                                @focus="setFocusedElement('passport')"
                            ></v-text-field>

                            <v-text-field
                                v-if="!$t('mask.passport')"
                                :label="$t('attributes.passport')"
                                outlined
                                v-model="form.passport.value"
                                v-validate="'required|max:20'"
                                :error-messages="errors.collect('passport')"
                                data-vv-name="passport"
                                required
                                @focus="setFocusedElement('passport')"
                            ></v-text-field>
                        </v-col>


                        <!-- <v-col cols="12" md="6">
                                <v-text-field
                                        :label="$t('second_name')"
                                        outlined
                                        v-model="form.second_name.value"
                                        v-validate="'required|max:50'"
                                        :error-messages="errors.collect('second_name')"
                                        data-vv-name="second_name"
                                        required
                                        @focus="setFocusedElement('second_name')"
                                ></v-text-field>
                            </v-col> -->
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field
                                :label="$t('mobile_phone')"
                                outlined
                                v-model="form.phone.value"
                                v-validate="'required'"
                                :error-messages="errors.collect('phone')"
                                data-vv-name="phone"
                                required
                                v-mask="$t('mask.phone')"
                                v-on:change="operatorCheck()"
                                @focus="setFocusedElement('phone')"
                            >
                                <template v-slot:append>
                                    <img
                                        v-if="operatorLogoPath"
                                        width="24"
                                        height="24"
                                        :src="operatorLogoPath"
                                        alt=""
                                    />
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" v-if="app_settings.is_password_required">
                            <v-text-field
                                label="Email"
                                outlined
                                v-model.trim="form.email.value"
                                v-validate="'required|email'"
                                :error-messages="errors.collect('email')"
                                data-vv-name="email"
                                required
                                @focus="setFocusedElement('email')"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <!-- <v-col cols="12" md="12">
                                <p class="subtitle-1 font-weight-bold">
                                    {{$t('password_description')}}</p>
                            </v-col> -->
                        <v-col cols="12" md="6" v-if="app_settings.is_password_required">
                            <v-text-field
                                :label="$t('attributes.password')"
                                outlined
                                v-model="form.password.value"
                                :type="form.password.show ? 'text' : 'password'"
                                :append-icon="form.password.show ? 'mdi-eye-off' : 'mdi-eye'"
                                @click:append="form.password.show = !form.password.show"
                                v-validate="{ required: true, min: 6, regex: /^[a-zA-Z0-9$@$!%*?&#^-_.+]+$/ }"
                                :error-messages="errors.collect('password')"
                                data-vv-name="password"
                                required
                                ref="password"
                            ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" md="6">
                                <v-text-field
                                    :label="$t('password_confirm')"
                                    outlined
                                    v-model="form.confirmPassword.value"
                                    :type="form.confirmPassword.show ? 'text' : 'password'"
                                    :append-icon="form.confirmPassword.show ? 'mdi-eye-off' : 'mdi-eye'"
                                    @click:append="form.confirmPassword.show = !form.confirmPassword.show"
                                    v-validate="'required|confirmed:password'"
                                    :error-messages="errors.collect('confirmPassword')"
                                    data-vv-name="confirmPassword"
                                    required
                                ></v-text-field>
                            </v-col> -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" lg="8">
                            <v-card elevation="0" class="card-shadow">
                                <v-card-text>
                                    <v-checkbox
                                        v-model="form.vendorConfirm"
                                        v-validate="'required'"
                                        :error-messages="errors.collect('vendorConfirm')"
                                        :value="true"
                                        label="Option"
                                        color="primary"
                                        data-vv-name="vendorConfirm"
                                        type="checkbox"
                                        required
                                        :false-value="null"
                                        :true-value="true"
                                    >
                                        <template v-slot:label>
                                            <div class="caption">
                                                {{ $t("vendor_confirm") }}
                                                <a href="#" @click="openPersonalDataModal()">
                                                    {{ $t("private_data") }}
                                                </a>
                                                {{ $t("advert_agree") }}
                                                <a href="#" @click="openUserTermsModal()">
                                                    {{ $t("public_offer") }}</a
                                                >.
                                            </div>
                                        </template>
                                    </v-checkbox>

                                    <v-checkbox
                                        v-if="app_settings.payments.subscription_confirm"
                                        v-model="form.subscriptionConfirm"
                                        v-validate="app_settings.payments.subscription_confirm_required ? 'required' : ''"
                                        :error-messages="errors.collect('subscriptionConfirm')"
                                        :value="true"
                                        label="Option"
                                        color="primary"
                                        data-vv-name="subscriptionConfirm"
                                        type="checkbox"
                                        required
                                        :false-value="null"
                                        :true-value="true">
                                        <template v-slot:label>
                                            <div class="caption">
                                                {{$t('pay.subscriptionConfirm')}}
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <div style="margin-top: 15px;" class="w100">
                            <v-btn depressed large class="w100" color="primary" @click="registrate()">
                                {{ $t("continue") }}
                            </v-btn>
                        </div>
                        <div class="mt-2 w100" >
                            <v-btn class="w100" depressed color="ligth-grey" to="/login">
                                <div class="anchor" style="font-size: 12px;">
                                    {{ $t("click_here_if_already_registered") }}
                                </div>
                            </v-btn>
                        </div>
                    </v-row>
                </form>
            </v-card-text>
        </RegistrationLayout>
        <overlay-loader :show="isRegistrationFormLoading"></overlay-loader>
        <ValidatePhone></ValidatePhone>
        <PersonalDataModal></PersonalDataModal>
        <UserTermsModal></UserTermsModal>
        <VerificateEmailModal :user="user"
                              :closable="!app_settings.is_email_required"
                              :pass="!app_settings.is_email_required"
                              :close-callback="paymentsCredentials"
        ></VerificateEmailModal>
    </div>
</template>

<script>
import moment from "moment";
import debounce from "debounce";
import settings from '@/environment';
import beeline from "@/assets/img/operators/beeline.png";
import mts from "@/assets/img/operators/mts.png";
import yota from "@/assets/img/operators/yota.png";
import t2 from "@/assets/img/operators/t2.png";
import megafone from "@/assets/img/operators/megafone.png";

import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import RegistrationLayout from "@/app/mobile/registration/shared/components/Layout";
import ValidatePhone from "@/app/mobile/registration/shared/components/ValidatePhone";
import VerificateEmailModal from "@/app/mobile/profile/shared/modals/verificateEmail";

import PersonalDataModal from "@/app/mobile/registration/shared/modals/PersonalDataModal";
import UserTermsModal from "@/app/mobile/registration/shared/modals/UserTermsModal";

export default {
    $_veeValidate: {
        validator: "new",
    },
    name: "RegFirstStep",
    components: {
        RegistrationLayout,
        OverlayLoader,
        ValidatePhone,
        PersonalDataModal,
        UserTermsModal,
        VerificateEmailModal
    },
    data() {
        return {
            birthdayMenu: false,
            _birthday: moment().format("YYYY-MM-DD"),
            addressSearch: "",
            load: false,
            validatePhone: false,
            focusedElement: { percent: 5 },
            focusedElementDescription: "",
            utm_marks: {},
        };
    },
    created() {
        this.focusedElement = this.form.surname;
        this.$store.dispatch("STORE_UTM", this.$route);
        this.$store.dispatch("GET_PERSONAL_AND_USER_TERMS_TEXTS");
        this.focusedElementDescription = this.app_settings.is_fio_required ? "surname" : "phone";
    },
    methods: {
        setFocusedElement(key) {
            this.focusedElement = this.form[key];
            this.focusedElementDescription = key;
        },
        sendUtms(profile_id) {
            let params = {
                utm_campaign: this.utm_marks.utm_campaign ? this.utm_marks.utm_campaign : "",
                utm_content: this.utm_marks.utm_content ? this.utm_marks.utm_content : "",
                utm_medium: this.utm_marks.utm_medium ? this.utm_marks.utm_medium : "",
                utm_source: this.utm_marks.utm_source ? this.utm_marks.utm_source : "",
                utm_term: this.utm_marks.utm_term ? this.utm_marks.utm_term : "",
                profile_id: profile_id,
            };
            this.$store.dispatch("SEND_UTMS", params);
        },
        operatorCheck() {
            this.$store.dispatch("CHECK_OPERATOR", this.fields);
        },

        debounceAddress: debounce(function (e) {
            this.$store.dispatch("GET_ADDRESS_HINT", e);
        }, 1000),

        setMetrics() {
            try {
                this.$metrika.reachGoal("reg");
            } catch (error) {
                console.log(error);
            }
        },
        verificatePhone() {
            this.$store.dispatch("SEND_PHONE_VERIFICATION_CODE")
                .then(() => {
                    this.$store.dispatch("OPEN_PHONE_VALIDATION");
                })
                .catch(() => {
                    this.$toast.error(this.$t("errors.cant_register"));
                });
        },

        verificateEmail() {
            this.$store.dispatch("SEND_EMAIL_VERIFICATION_CODE")
                .then(() => {
                    this.$toast.success(
                        this.$t("we_sent_mail_to_your_email_register", { email: this.user.email })
                    );
                    this.$store.dispatch('EMAIL_VALIDATION', true);
                })
                .catch((error) => {
                    const exception = error.response.data.exception;
                    switch (exception) {
                        case "VerificationCodeAlreadySentException":
                            this.$toast.warning(
                                this.$t(`exception.${exception}`, { type: "Email" })
                            );
                            break;
                        default:
                            this.$toast.error(this.$t("errors.we_cant_send_email"));
                            break;
                    }
                });
        },

        checkRequisites() {
            this.$router.push({
                path: `/check-requisites?api_key=${this.$store.getters.GET_REGISTRATED_USER_APIKEY}`,
            });
        },

        paymentsCredentials() {
            this.$router.push({
                path: `/payment-credentials?api_key=${this.$store.getters.GET_REGISTRATED_USER_APIKEY}`,
            });
        },

        registrate() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch("SET_LOAN_POSSIBILITY", this.loanPossibility);
                    this.$store.dispatch("REGISTRATE")
                        .then((result) => {
                            this.setMetrics();
                            // this.sendUtms(result.id);

                            if (this.app_settings.is_phone_required)
                                return this.verificatePhone();

                            if (this.app_settings.is_mailgun_ok && this.app_settings.is_email_required)
                                return this.verificateEmail();

                            if (
                                this.app_settings.payments.enabled &&
                                this.app_settings.payments.registration &&
                                this.app_settings.payments.after_check_requisites
                            ) {
                                return this.checkRequisites();
                            }

                            if (this.app_settings.payments.registration)
                                return this.paymentsCredentials();

                            this.checkRequisites();
                        })
                        .catch((error) => {
                            const exception = error.response.data.exception;
                            switch (exception) {
                                case "UserAlreadyRegisteredException":
                                    this.$toast.warning(this.$t(`exception.${exception}`));
                                    break;
                                default:
                                    this.$toast.error(this.$t("errors.cant_register"));
                                    break;
                            }
                        });
                }
            });
        },
        openPersonalDataModal() {
            this.$store.dispatch("PERSONAL_DATA_MODAL", true);
            this.form.vendorConfirm = !this.form.vendorConfirm;
        },
        openUserTermsModal() {
            this.$store.dispatch("USER_TERMS_MODAL", true);
            this.form.vendorConfirm = !this.form.vendorConfirm;
        },
    },
    computed: {
        user() {
            return this.$store.getters.GET_REGISTRATED_USER;
        },
        app_settings() {
            return this.$store.getters.APP_SETTINGS;
        },
        getPossibilityHint() {
            return this.$t("possibility_hint", {
                percent: this.focusedElement.percent,
                field: this.$t(`possibility_hint_vars.${this.focusedElementDescription}`),
            });
        },
        isPhoneVerificated() {
            return this.$store.getters.IS_PHONE_VERIFICATED;
        },
        isRegistrationFormLoading() {
            return this.$store.getters.REGISTRATION_IS_LOADING;
        },
        isAddressHintsLoading() {
            return this.$store.getters.GET_ADDRESS_HINT_LOADING;
        },
        addressHints() {
            return this.$store.getters.GET_ADDRESS_HINT;
        },
        operatorLogoPath() {
            const operator = this.$store.getters.GET_PHONE_NUMBER_OPERATOR;
            let path = "";
            switch (operator) {
                case "Билайн":
                    path = beeline;
                    break;
                case "МТС":
                    path = mts;
                    break;
                case "Мегафон":
                    path = megafone;
                    break;
                case "Yota":
                    path = yota;
                    break;
                case "Теле2":
                    path = t2;
                    break;
            }
            return path;
        },
        form() {
            return this.$store.getters.GET_REGISTRATION_CREDITIONALS;
        },
        loanPossibility() {
            const validated = [];
            for (const key in this.fields) {
                if (this.fields[key].valid) {
                    validated.push(this.form[key]);
                }
            }
            return (
                this.startPossibility +
                validated.reduce(
                    (prev, current) => (current && current.percent ? prev + current.percent : prev),
                    0
                )
            );
        },
        startPossibility() {
            return this.$store.getters.START_LOAN_POSSIBILITY;
        },
        computedBirthday: {
            get() {
                return this._birthday;
            },
            set(value) {
                if (value) {
                    this._birthday = value;
                    this.form.birthday.value = moment(value).format("DD.MM.YYYY");
                    this.form.birthday.ISOFormatted = moment(value).format("YYYY-MM-DD");
                }
            },
        },
    },
    watch: {
        addressSearch(val) {
            val && val !== this.form.address.value && this.debounceAddress(val);
        },
        isPhoneVerificated(val) {
            if (val) {
                this.app_settings.is_mailgun_ok
                    ? this.verificateEmail()
                    : this.paymentsCredentials();
            }
        },
    },
};
</script>

<style>
.registration-card {
    padding: 40px 40px 0;
}

@media (max-width: 960px) {
    .registration-card {
        padding: 20px 10px;
    }
}
</style>
